export default "__VITE_ASSET__BRIZJ4$d__"